import { cx } from '@platform/core/lib/cx';
import type { IPageHeaderProps } from './IPageHeaderProps';

/**
 * Шапка сторінки модуля (прототип v4, UIUX foundations/typography): необов'язковий рядок над заголовком (12px/600 великими літерами,
 * приглушений), заголовок h1 (20px/600, −0.01em; з плиткою модуля ліворуч, як на сторінках проєктування, — 22px) з бейджем, рядок опису
 * (13px, приглушений); дії сторінки — праворуч.
 */
export function PageHeader({ eyebrow, title, description, badge, tile, actions }: IPageHeaderProps) {
  return (
    <div className={cx('lv-head', Boolean(tile) && 'lv-head--tile')}>
      <div className="lv-head__main">
        {tile}
        <div className="lv-head__text">
          {eyebrow && <span className="lv-head__eyebrow">{eyebrow}</span>}
          <h1 className="lv-head__title">{title}{badge}</h1>
          {description && <p className="lv-head__desc">{description}</p>}
        </div>
      </div>
      {actions && <div className="lv-head__actions">{actions}</div>}
    </div>
  );
}
